import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, Label, Legend } from 'recharts';
import { Stack } from '@mui/material';
import { useMemo, useState } from 'react';

import { colours } from 'theme';

import { KeyPicker } from 'Chart/KeyPicker';
import NoneToDisplay from 'Chart/NoneToDisplay';
import NewSimulationButton from './NewSimulationButton';

export const RenderChart = ({ data, humanReadableKeys, keys, units }) => {

    const [selected_key, setKey] = useState('rate_slurry_methane')

    const unit = useMemo(() => {
        return units?.[selected_key] ?? '';
    }, [units, selected_key]);

    const transformChartData = (runsData, selected_key) => {
        // Build a map of dates and collect values from each run
        const dateMap = new Map();
        
        runsData.forEach(({ run_id, data }) => {
            data.forEach(entry => {
                const date = entry.date;
                if (!dateMap.has(date)) dateMap.set(date, { date });
            
                // Add value under a new key per run
                dateMap.get(date)[`${selected_key}_run_${run_id}`] = entry[selected_key];
            });
        });
        
        // Return as array sorted by date
        return Array.from(dateMap.values()).sort((a, b) => new Date(a.date) - new Date(b.date));
    }

    const chartData = useMemo(() => transformChartData(data, selected_key), [data, selected_key]);

    const colors = [colours.purple, colours.green, colours.orange, colours.pink, colours.blue];

    const chartExists = chartData?.length > 0
   
    return chartExists ? (
        <Stack direction='column' alignItems='center' justifyContent='center'>
            <Stack sx={{ my: 3 }}>
                <KeyPicker setKey={setKey} keys={keys} selected_key={selected_key} human_readable={humanReadableKeys}/>
            </Stack>
            <ResponsiveContainer width='90%' aspect={3.5}>
                <LineChart data={chartData} margin={{ right: 25, left: 25 }}>
                    <XAxis dataKey='date' />
                    <YAxis>
                        <Label value={unit} angle={-90} dx={-15} position='insideLeft' />
                    </YAxis>
                    <Legend />
                    {data.map((run, index) => (
                        <Line
                            key={run.run_id}
                            type='monotone'
                            dataKey={`${selected_key}_run_${run.run_id}`}
                            stroke={colors[index % colors.length]}
                            name={`Empty ${new Date(run.date_empty).toLocaleDateString('en-GB')}`}
                            dot={false}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
            <NewSimulationButton />
        </Stack>
    ) : <NoneToDisplay object='charts' />
  };
  